const IMAGE_TYPES = ['image/gif', 'image/jpg', 'image/jpeg', 'image/png', 'image/webp']
const IMAGE_MAX_SIZE = 1000 * 1000 // 1 Mo

function getImageDimensions(file) {
  const img = new Image()
  const promise = new Promise((resolve, reject) => {
    img.onload = () => {
      const width = img.naturalWidth
      const height = img.naturalHeight
      resolve({ width, height })
      URL.revokeObjectURL(img.src)
    }
    img.onerror = reject
  })
  img.src = URL.createObjectURL(file)
  return promise
}

export default function yupImage(options = {}) {
  options.minHeight = options.minHeight || 0
  options.minWidth = options.minWidth || 0
  options.maxSize = options.maxSize || IMAGE_MAX_SIZE
  options.types = options.types || IMAGE_TYPES
  return yupFile({
    maxSize: options.maxSize,
    types: options.types
  }).test({
    name: 'imageDimensions',
    message: `Image trop petite (${options.minWidth} x ${options.minHeight} minimum)`,
    test: async value => {
      try {
        if (!(value instanceof File)) return true
        const { height, width } = await getImageDimensions(value)
        return height >= options.minHeight && width >= options.minWidth
      } catch (error) {
        console.error(error)
        return true
      }
    }
  })
}
